import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent } from "@/components/ui/card";

const FIELD_LABELS = {
  estimated_value: "Valor Estimado",
  approved_value: "Valor Aprovado",
  billed_value: "Valor Faturado",
  received_value: "Valor Recebido",
  adjustments: "Ajustes / Glosa",
};

/** Tab "Financeiro" — edit the per-case financial values. */
export default function FinanceiroTab({ edit, setEdit, onSave }) {
  function setField(k, v) {
    setEdit({
      ...edit,
      financials: {
        ...(edit.financials || {}),
        [k]: v === "" ? null : parseFloat(v),
      },
    });
  }
  return (
    <Card><CardContent className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
      {Object.entries(FIELD_LABELS).map(([k, label]) => (
        <div key={k} className="space-y-1.5">
          <Label>{label}</Label>
          <Input
            type="number"
            step="0.01"
            inputMode="decimal"
            value={edit.financials?.[k] ?? ""}
            onChange={(e) => setField(k, e.target.value)}
          />
        </div>
      ))}
      <div className="md:col-span-2 space-y-1.5">
        <Label>Observações financeiras</Label>
        <Textarea
          rows={2}
          value={edit.financials?.notes || ""}
          onChange={(e) => setEdit({ ...edit, financials: { ...(edit.financials || {}), notes: e.target.value } })}
        />
      </div>
      <div>
        <Button onClick={onSave} className="bg-blue-700 hover:bg-blue-800 h-11 md:h-9 w-full sm:w-auto">Salvar financeiro</Button>
      </div>
    </CardContent></Card>
  );
}
